import {UUID} from "@/libs/magic";
import randomstring from "randomstring";

export function compare_entering_data(new_data, old_data) {
    console.clear()

    // Формируем массив новых отчётов, которых нет
    let new_reports = []
    for (let report of new_data.data) {
        let not_new = old_data.data.find(r => r.unique_guid === report.unique_guid)
        if (!not_new) {
            new_reports.push(report)
        }
    }

    // Формируем массив отчётов, которые надо удалить
    let outdated_reports = []
    for (let report of old_data.data) {
        let not_outdated = new_data.data.find(r => r.unique_guid === report.unique_guid)
        if (!not_outdated) {
            outdated_reports.push(report)
        }
    }

    console.log('Устаревшие - к удалению:')
    console.log(outdated_reports)
    console.log('Новые - к добавлению:')
    console.log(new_reports)

    // Обновляем существующие отчёты
    for (let section of old_data.section_list) {
        for (let page of section.groups) {
            for (let report of page.reports) {
                let updated = new_data.data.find(r => r.unique_guid === report.unique_guid)
                if (updated) {
                    report.report_data = updated.report_data
                }
            }
        }
    }


    // Создаём новые разделы
    // Добавляем новые отчёты в разделы
    if (new_reports.length > 0) {
        for (let [index, new_report] of new_reports.entries()) {
            let section = old_data.section_list.findIndex(el => el.name === new_report.report_group)
            // Если нет раздела - создаём
            if (section < 0) {
                old_data.section_list.push({
                    name: new_report.report_group,
                    guid: UUID(),
                    groups: []
                })
            }

            // Создаём страничку
            let page = {
                guid: randomstring.generate(16),
                name: `group_${index}`,
                /*page: this.pages, */
                type: "group",
                reports: [new_report]
            }

            // Запихиваем отчёт в нужный раздел
            let section_index = old_data.section_list.findIndex(el => el.name === new_report.report_group)
            old_data.section_list[section_index].groups.push(page)
        }
    }

    // Удаляем устаревшие отчёты
    if (outdated_reports.length > 0) {
        console.log(`Есть ${outdated_reports.length} отчётов к удалению`)
        for (let outdated of outdated_reports) {
            for (let section of old_data.section_list) {
                for (let page of section.groups) {
                    for (let [index_report, report] of page.reports.entries()) {
                        if (outdated.unique_guid === report.unique_guid) {
                            console.log(`Удаляем ${outdated.unique_guid}!`)
                            page.reports.splice(index_report, 1)
                        }
                    }
                }
            }
        }
    }

    // Очищаем пустышки
    for (let i = old_data.section_list.length - 1; i >= 0; i--) {
        for (let j = old_data.section_list[i].groups.length - 1; j >= 0; j--) {
            if (old_data.section_list[i].groups[j].reports.length === 0) {
                console.log(`Страница без отчёта, удаляем!`)
                old_data.section_list[i].groups.splice(j, 1)
            }
        }
        if (old_data.section_list[i].groups.length === 0) {
            console.log(`Раздел без страниц, удаляем!`)
            old_data.section_list.splice(i, 1)
        }
    }


    old_data.data = new_data.data
    return old_data
}
